import React, { useState } from "react";
import { cn } from "@/lib/utils";

export default function TextInput({
  label,
  type = "text",
  inputStyles,
  containerStyles,
  handleInputChange,
  onBlur,
  icon,
  formatInput,
  value,
  setValue,
  error,
  ...props
}: {
  label: string;
  type?: string;
  inputStyles?: string;
  containerStyles?: string;
  handleInputChange?: (value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  icon?: React.ReactElement;
  formatInput?: (value: string) => string;
  value: string;
  setValue: (value: string) => void;
  error: string | undefined;
}) {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className={cn("space-y-px rounded bg-white", containerStyles)}>
      <div className="relative w-full">
        <input
          {...props}
          type={type}
          value={value}
          onChange={(e) => {
            const inputValue = e.target.value;
            const formattedValue = formatInput
              ? formatInput(inputValue)
              : inputValue;
            setValue(formattedValue);
            handleInputChange?.(formattedValue);
          }}
          className={cn(
            "inputText peer h-input relative z-10 rounded border-0 pt-5 text-base focus:z-20 focus:ring-2 focus:ring-black focus:ring-inset sm:text-sm",
            inputStyles,
            error &&
              "ring-1 ring-red-500 ring-inset focus:ring-1 focus:ring-red-500",
          )}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur?.(e);
          }}
          onFocus={() => setIsFocused(true)}
          ref={(input) => {
            if (input && isFocused) {
              input.focus();
            }
          }}
        />
        <span
          className={cn(
            "absolute top-1/2 left-3 z-30 -translate-y-1/2 transform text-sm transition-all",
            "peer-placeholder-shown:top-1/2 peer-placeholder-shown:text-gray-500",
            "peer-focus:top-1/4 peer-focus:text-xs",
            "text-gray-400 peer-focus:text-gray-700",
            (value || isFocused || type === "date") && "top-1/4 text-xs",
            error && "text-red-500 peer-focus:text-red-500",
          )}
          onClick={() => setIsFocused(true)}
        >
          {error ? error : label}
        </span>
        {icon}
      </div>
    </div>
  );
}
